class RecentlyViewedMto extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'spectra_recently_viewed';
    this.handle = this.dataset.handle;
    this.limit = parseInt(this.dataset.limit, 10) || 8;
    this.remember();
    this.render();
  }

  read() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch (e) {
      return [];
    }
  }

  remember() {
    if (!this.handle) return;
    try {
      const viewed = this.read().filter((h) => h !== this.handle);
      viewed.unshift(this.handle);
      localStorage.setItem(this.storageKey, JSON.stringify(viewed.slice(0, 20)));
    } catch (e) {}
  }

  async render() {
    const handles = this.read().filter((h) => h !== this.handle).slice(0, this.limit);
    if (!handles.length) return;

    const cards = await Promise.all(handles.map((h) => this.fetchCard(h)));
    const items = cards.filter(Boolean);
    if (!items.length) return;

    const shell = this.querySelector('template[data-shell]').content.cloneNode(true);
    const list = shell.querySelector('ul');
    const sectionId = this.dataset.sectionId;
    items.forEach((li, i) => {
      li.id = `Slide-${sectionId}-${i + 1}`;
      list.appendChild(li);
    });
    // the slider is built after its cards exist so SliderComponent counts every slide
    this.querySelector('[data-results]').replaceChildren(shell);
    this.hidden = false;
  }

  async fetchCard(handle) {
    try {
      const res = await fetch(`${window.Shopify.routes.root}products/${handle}?section_id=${this.dataset.sectionId}`);
      if (!res.ok) return null;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const tpl = doc.querySelector('template[data-card]');
      if (!tpl) return null;
      return document.importNode(tpl.content.firstElementChild, true);
    } catch (e) {
      return null;
    }
  }
}

customElements.define('recently-viewed-mto', RecentlyViewedMto);
